export function substituirItemEmArray<T> (
    array: T[],
    predicado: (item: T) => boolean,
    novoItem: any
) : T[] {
    const arrayCopia = [...array]

    const indiceItemAntigo = arrayCopia.findIndex(predicado)

    if (indiceItemAntigo == -1) {
        arrayCopia.push(novoItem)
    } else {
        arrayCopia.splice(
            indiceItemAntigo,
            1,
            novoItem
        )
    }

    return arrayCopia
}